











































































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { ItemVitrineVirtual, VitrineVirtualModule } from '@/store/vuex/produto/VitrineVirtualStore'
import { hashColor } from '@/shareds/badge-utils'
import Confirmacao from '@/components/ui/Confirmacao.vue'

@Component({
	components: {
		Confirmacao,
	},
})
export default class DialogoDeCarrinhoDaVitrineVirtual extends Vue {
	@Ref() confirmacaoDeLimparCarrinho!: Confirmacao

	mostra = false
	adicionandoNaVenda = false
	hashColor = hashColor
	imagemPadrao = 'https://i.pinimg.com/originals/61/3c/ea/613ceaae3543acdf381af20da47612dc.png'

	mostrar() {
		this.mostra = true
	}

	fechar() {
		this.mostra = false
		this.adicionandoNaVenda = false
	}

	get itensCarrinho(): ItemVitrineVirtual[] {
		return VitrineVirtualModule.dados.produtos || []
	}

	get valorTotal(): number {
		return this.itensCarrinho.reduce((total, item) => {
			return total + ((item.produto.preco || 0) * item.quantidade)
		}, 0)
	}

	get valorTotalFormatado(): string {
		return this.formatarValor(this.valorTotal)
	}

	formatarValor(valor: number): string {
		return new Intl.NumberFormat('pt-BR', {
			style: 'currency',
			currency: 'BRL',
		}).format(valor || 0)
	}

	substituirPelaImagemPadrao(evento: Event) {
		const imagem = evento.target as HTMLImageElement
		if (imagem.src === this.imagemPadrao) return
		imagem.src = this.imagemPadrao
	}

	getImagem(item: ItemVitrineVirtual): string {
		const produto = item.produto

		if (!produto?.urlImagens) return this.imagemPadrao

		if (typeof produto.urlImagens === 'string') {
			return produto.urlImagens
		}

		if (Array.isArray(produto.urlImagens) && produto.urlImagens.length) {
			const padrao = produto.urlImagens.find((img: any) => img.padrao === true)
			const imagem = padrao || produto.urlImagens[0]

			if (typeof imagem === 'string') return imagem
			if (imagem?.imagemUrl) return imagem.imagemUrl
		}

		if ((produto.urlImagens as any)?.imagemUrl) {
			return (produto.urlImagens as any).imagemUrl
		}

		if ((produto.urlImagens as any)?.url) {
			return (produto.urlImagens as any).url
		}

		return this.imagemPadrao
	}

	removerItem(item: ItemVitrineVirtual) {
		const itensAtualizados = this.itensCarrinho.filter((i) => i.produto.id !== item.produto.id)

		VitrineVirtualModule.setDados({
			produtos: itensAtualizados,
		})
	}

	async confirmarLimpar() {
		const confirmou = await this.confirmacaoDeLimparCarrinho.mostrar()
		if (!confirmou) return
		this.limparCarrinho()
	}

	limparCarrinho() {
		VitrineVirtualModule.resetar()
	}

	concluir() {
		if (this.adicionandoNaVenda) return
		this.adicionandoNaVenda = true
		this.$emit('finalizar', this.itensCarrinho)
	}
}
